import FgReplace from "./FgReplace";
export default FgReplace;
